import React, { useState } from 'react';
import { useI18n } from '../../i18n/i18nService'; // Assurez-vous que i18n est correctement configuré
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom'; // Importe Link et useLocation
import SearchBar from './SearchBar';
import NotificationDropdown from './NotificationBox';
import ChatBox from './ChatBox';
import UserBox from './UserBox';
import { LanguageSelector } from '../LanguageSelector';




function Header({ changeLanguage, currentLanguage }) {
    const { t } = useI18n();
    const { isAuthenticated, logout } = useAuth(); // Récupère les infos d'auth
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const handleSearch = (searchTerm) => {
        if (searchTerm.trim()) {
            // 🔍 Traite la recherche ici (API, navigation, etc.)
            console.log('Requête de recherche :', searchTerm);
        }
    };
    return (
        <header className="bg-light-primary dark:bg-dark-surface text-white shadow-md sticky top-0 z-50">
            <div className="grid grid-cols-[auto_1fr_auto] items-center gap-4 py-2 px-4 bg-light-primary dark:bg-dark-surface text-white">

                <div className="flex items-center">
                    {/* Logo */}
                    <div className="flex flex-col items-center space-x-1">
                        <img
                            src="/images/logo.png" // Assurez-vous que le chemin est correct
                            alt="IDARAF"
                            className="h-16 w-16 object-contain"
                        />
                        {/* <h1 className="text-2xl font-bold tracking-tight">IDARAF</h1> */}
                    </div>
                </div>
                {/* Menu mobile ouvert */}
                {mobileMenuOpen && (
                    <div className="md:hidden mt-3 pt-3 border-t border-light-primary/20 dark:border-dark-primary/20">
                        <div className="flex flex-col space-y-3">
                            <LanguageSelector
                                currentLanguage={currentLanguage}
                                onChange={(lang) => {
                                    changeLanguage(lang);
                                    setMobileMenuOpen(false);
                                }}
                                mobile
                            />
                            {isAuthenticated && (
                                <button
                                    onClick={logout}
                                    className="w-full text-left px-3 py-2 rounded-md text-red-400 hover:bg-red-500/10"
                                >
                                    {t('logout')}
                                </button>
                            )}
                        </div>
                    </div>
                )}
                <div className="flex justify-center">
                    {/* Barre de recherche */}
                    <SearchBar onSearch={handleSearch} />
                </div>

                <div className="flex justify-end space-x-4 items-center">
                    {/* LanguageSelector, ThemeToggle, Auth */}
                    <div className="flex items-center space-x-4">
                        {/* Sélecteur de langue - Desktop */}
                        <div className="hidden md:block">
                            <LanguageSelector
                                currentLanguage={currentLanguage}
                                onChange={changeLanguage}
                            />
                        </div>

                        {/* Menu utilisateur */}
                        {isAuthenticated ? (
                            <>
                                <NotificationDropdown />
                                <ChatBox messages={[]} />
                                <UserBox />
                            </>

                        ) : (
                            <Link
                                to="/login"
                                className="px-3 py-1 rounded-md bg-light-secondary dark:bg-dark-secondary text-light-text dark:text-dark-bg text-sm font-medium hover:opacity-90 transition-opacity"
                            >
                                {t('login')}
                            </Link>
                        )}

                        {/* Menu mobile */}
                        <button
                            className="md:hidden p-1 rounded-md hover:bg-light-primary/20 dark:hover:bg-dark-primary/20"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
